module.exports = __webpack_public_path__ + "img/blog-details.2c1ac759.png";